import "../../styles/cards.css";

export const TextCard = ({caption,text}) => {

    return (
        <div className="txt-card-container">
            <div className="txt-card-caption">{caption}</div>
            <div className="txt-card-txt">{text}</div>
        </div>
    )
}